// extracted by mini-css-extract-plugin
module.exports = {"failure":"styles_failure___Ai2S"};